export default "__VITE_ASSET__S1$BYtcM__"